var getStackTrace = function () {
    var dummyError = new Error();
    return dummyError.stack ? dummyError.stack.toString() : '';
};
export var getAppUrl = function (appName) {
    var urlMatches = getStackTrace().match(new RegExp("https?://.*?".concat(appName, ".*?.js")));
    return urlMatches ? urlMatches[0] : '';
};
export var isLocalhost = function () {
    return /localhost|127\.0\.0\.1|::1|\.local|local.wix.com|^$/i.test(window.location.hostname);
};
//# sourceMappingURL=getUrl.js.map